import debounce from 'lodash/debounce';
import { useEffect } from 'react';

export default function useWindowResize(callback: () => void, debounceDelay = 500): void {
  useEffect(() => {
    const _handler = debounce(callback, debounceDelay);
    window.addEventListener('resize', _handler);

    return () => {
      window.removeEventListener('resize', _handler);
    };
  }, [callback, debounceDelay]);
}
